import React from "react";

export const Phone = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1591_28717)">
      <path
        d="M13.985 13.3128L12.7004 14.58C12.0305 14.1761 11.4082 13.6981 10.8452 13.155C10.303 12.5911 9.82505 11.9687 9.42023 11.2992L10.6862 10.0146C10.7629 9.93675 10.8147 9.83784 10.835 9.73046C10.8553 9.62309 10.8432 9.5121 10.8002 9.41162L9.48023 6.33482C9.42808 6.2135 9.33408 6.11495 9.21536 6.05713C9.09664 5.99931 8.9611 5.98607 8.83343 6.01982L6.41303 6.66002C6.29216 6.69135 6.1855 6.76278 6.11051 6.86263C6.03552 6.96247 5.99664 7.0848 6.00023 7.20962C6.15423 10.0247 7.3247 12.6882 9.29423 14.7054C11.3118 16.6756 13.9761 17.8463 16.7918 18C16.9168 18.0042 17.0394 17.9657 17.1394 17.8907C17.2395 17.8157 17.3109 17.7089 17.342 17.5878L17.9816 15.1662C18.0155 15.0386 18.0024 14.9031 17.9447 14.7843C17.887 14.6656 17.7885 14.5716 17.6672 14.5194L14.5898 13.2C14.4892 13.1564 14.3779 13.1439 14.2702 13.164C14.1624 13.1841 14.0631 13.2359 13.985 13.3128Z"
        stroke="#0D0C1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1591_28717">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
